var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 14.0004C41.924 14.0004 50 22.0744 50 32.0004C50 38.9144 46.118 45.1044 40 48.1284V52.0004C40 56.4124 36.412 60.0004 32 60.0004C27.588 60.0004 24 56.4124 24 52.0004V48.1284C17.882 45.1044 14 38.9144 14 32.0004C14 22.0744 22.076 14.0004 32 14.0004ZM36 52.0004H28C28 54.2044 29.794 56.0004 32 56.0004C34.206 56.0004 36 54.2044 36 52.0004ZM32 18.0004C24.28 18.0004 18 24.2804 18 32.0004C18 37.7344 21.434 42.8304 26.75 44.9824C27.506 45.2864 28 46.0224 28 46.8364V48.0004H30V35.9964H34V48.0004H36V46.8364C36 46.0224 36.494 45.2864 37.25 44.9824C42.566 42.8304 46 37.7344 46 32.0004C46 24.2804 39.72 18.0004 32 18.0004ZM10 29.998V34H4V29.998H10ZM60 29.998V34H54V29.998H60ZM50.3514 10.801L53.1794 13.629L48.9374 17.871L46.1094 15.043L50.3514 10.801ZM13.629 10.753L17.871 14.997L15.043 17.825L10.801 13.581L13.629 10.753ZM34.002 4V10H30V4H34.002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.7d2585ba004c9832e8f96b9321b38ae0.svg";
export { ForwardRef as ReactComponent };